import React from 'react';
import Modal from 'react-modal';
import { withRouter } from 'react-router-dom';
import '../LoginModals.css';
import { UserFlowModalState } from '../../UserFlow/UserFlowModal';
import { useVerifyUserNameContainer } from '../verifyIrctcUsername/UsernameContainer';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

const GetUserNameSuccess = (props: UserFlowModalState) => {
  const {
    props: {
      userStatus,
      showModal,
      error,
    },

    action: {
      closeModal,
      goToIRCTCRegistrationPage,
      goToForgotUsernamePage,
    },
  } = useVerifyUserNameContainer(props);

  return (
    <Modal
      isOpen={showModal}
      ariaHideApp={false}
      onRequestClose={closeModal}
      className='loginModals loginModals--v3'
      id="get-username-success"
      style={{
        overlay: {
          backgroundColor: 'rgb(0, 0, 0, 0.6)',
          zIndex: 1,
        },
        customStyles,
      }}
    >
      <p className='textRight makeFlex spaceBetween start modalCloseCont accountSuccess'>
        <span className="font26 latoBlack accountCreatedRound appendRight5 textCenter"><span className="checkmark">  </span></span>
        <span
          className='modalClose railSprite crossIcon'
          onClick={closeModal}>
        </span>
      </p>

      <p className='font20 latoBold blackText appendBottom10 appendTop20'>Username Sent</p>
      <p className='font14 lineHeight20 appendBottom40'>You will get an email<span className="latoBold">{userStatus.emailEntered}</span> from IRCTC with your username within 1-2 mins.</p>

      <div className='end'>

        <p className='makeFlex hrtlCenter font14 darkGreyText paddingT10 appendBottom5'>
          <span>Didn’t receive username?</span>
          {/*<span className="timer">*/}
          {/*  <span className="railSprite timerIcon appendRight5"></span>*/}
          {/*  <span className="whiteText latoBlack"> 00 : 26s</span>*/}
          {/*</span>*/}
        </p>
        <p className='appendBottom20 opactityD6' onClick={goToForgotUsernamePage}><a className='font16 latoBold '>Resend Username</a></p>

        <p className='font14 darkGreyText paddingT20 appendBottom5'>Facing trouble?</p>
        <p><a className='font16 latoBold ' onClick={goToIRCTCRegistrationPage}>Create New Account</a></p>

      </div>
    </Modal>
  );
};

export default withRouter(GetUserNameSuccess);
